import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    communityListFeatureKey,
    CommunityListState,
} from './community-list.reducer';

export const communityListState = createFeatureSelector<CommunityListState>(
    communityListFeatureKey
);

export const selectCommunityList = (id) =>
    createSelector(
        communityListState,
        (state) => state.entities[id]?.list || []
    );
